export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const API_ENDPOINTS = {
  USERS: '/api/users',
  CHAT: '/api/chat',
  SUMMARIES: '/api/summaries',
  SUMMARIZE: '/api/summarize-langchain',
  CREDITS: (uid: string) => `/api/credits/${uid}`,
  CREATE_CHECKOUT: '/api/create-checkout-session',
  VERIFY_PAYMENT: '/api/verify-payment',
  DOWNLOAD: (id: string) => `/api/documents/${id}/download`,
  DELETE_DOCUMENT: (id: string) => `/api/documents/${id}`,
  CREDIT_HISTORY: '/api/credits/history',
  STRIPE_ASSISTANT: '/api/stripe-assistant',
};

export const getApiUrl = (endpoint: string) => `${API_BASE_URL}${endpoint}`;

// Helper function for making authenticated API calls
export const fetchWithAuth = async (endpoint: string, options: RequestInit = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
    mode: 'cors',
    credentials: 'include',
  };

  const response = await fetch(getApiUrl(endpoint), config);

  if (!response.ok) {
    const error = await response.text();
    throw new Error(`API call failed: ${error}`);
  }

  return response;
};
